import React, { memo } from "react";
import { SkeletonBar } from "components/skeleton";

type Props = {
  showQuantity?: boolean;
  showPrice?: boolean;
  showStatus?: boolean;
};

function AddFolderProductsSkeletonRowImpl({
  showQuantity = false,
  showPrice = false,
  showStatus = true,
}: Props) {
  return (
    <tr aria-hidden="true" className="ui-skeleton-table-row">
      <td>
        <div className="add-folder-products-modal__product-row add-folder-products-modal__product-row--skeleton">
          <SkeletonBar
            className="add-folder-products-modal__product-row-checkbox-skeleton"
            width="1.25rem"
            height="1.25rem"
          />
          <div className="add-folder-products-modal__product-row-text-skeleton">
            <SkeletonBar className="add-folder-products-modal__product-row-name-line-skeleton" />
            <SkeletonBar className="add-folder-products-modal__product-row-label-line-skeleton" />
          </div>
        </div>
      </td>
      <td className="add-folder-products-modal__type-cell">
        <SkeletonBar className="add-folder-products-modal__type-cell-skeleton" />
      </td>
      {showPrice ? (
        <td className="add-folder-products-modal__price-cell">
          <SkeletonBar width="4.5rem" height="1rem" />
        </td>
      ) : null}
      {showQuantity ? (
        <td className="add-folder-products-modal__qty-cell">
          <SkeletonBar width="4rem" height="2rem" />
        </td>
      ) : null}
      {showStatus ? (
        <td className="add-folder-products-modal__badge-cell">
          <SkeletonBar className="add-folder-products-modal__badge-cell-skeleton" />
        </td>
      ) : null}
    </tr>
  );
}

const AddFolderProductsSkeletonRow = memo(AddFolderProductsSkeletonRowImpl);
AddFolderProductsSkeletonRow.displayName = "AddFolderProductsSkeletonRow";

export default AddFolderProductsSkeletonRow;
